import React, { ComponentPropsWithoutRef } from 'react';
import { Container } from './styles';

interface Props extends ComponentPropsWithoutRef<'button'> {
  color?: string;
  visible?: boolean;
}

const Button: React.FC<Props> = ({
  color,
  visible = true,
  children,
  ...rest
}) => {
  return (
    <Container
      color={color}
      style={visible ? {} : { display: 'none' }}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default Button;
